export enum CallNotificationType {
  AUTO_LOGOUT = 'AutoLogout',
  PUSHED_CALL_TIMEOUT = 'PushedCallTimeout',
  CALL_DISCONNECTED = 'CallDisconnect',
  NEW_CALL = 'NewCall',
  CALL_STARVATION_TIMEOUT = 'CallStarvationTimeout',
  INITIATE_DIAL = 'InitiateDial',
  INITIAL_INFO_TEAMING = 'InitialInfoTeaming',

  TEAMING_REQUEST = 'TeamingRequest',
  TEAMING_ACCEPTED = 'TeamingAccepted',
  TEAMING_CANCELED = 'TeamingCanceled',
  TEAMING_BEGIN = 'TeamingBegin',
  TEAMING_END = 'TeamingEnd',
  TEAMING_HANDOFF = 'TeamingHandoff',
  SYNC_CALL_TIMER = 'SyncCallTimer',
  SYNC_CALL_TYPE = 'SyncCallType',
  SYNC_EMERGENCY_CALL_PROVISION = 'SyncEmergencyCallProvision',
  TEAMING_USER_CONNECTION_SUCCESS = 'TeamingUserConnectionSuccess',
  TEAMING_USER_CONNECTION_FAILED = 'TeamingUserConnectionFailed',
  TEAMING_USER_COULD_NOT_CONNECT_TO_TEAMING = 'TeamingUserCouldNotConnectToTeaming',

  TEAMING_HEARINGS_SYNC_UPDATE = 'TeamingHearingsSyncUpdate',

  HANDOFF_CALL = 'HandoffCall',
  HANDOFF_ACCEPTED = 'HandoffAccepted',
  HANDOFF_CANCELED = 'HandoffCanceled',
  HANDOFF_CALL_SENT = 'HandoffCallSent',

  ADMIN_AUTO_LOGOUT = 'AdminAutoLogout',
  ADMIN_CANCELED_CALL = 'AdminCanceledCall',
  ADMIN_TEAMING_CANCELED = 'AdminTeamingCanceled',
  ADMIN_TEAMED_USER_LOGOUT = 'AdminTeamedUserLogout',
  REMOTE_TEAMED_USER_LOGOUT = 'RemoteTeamedUserLogout',

  MONITOR_START = 'MonitorStart',
  MONITOR_END = 'MonitorEnd',

  HEARING_DECLINED_CALL = 'HearingDeclinedCall',
  SPAWN_CALL = 'SpawnCall',
  INFO_FOR_VI = 'InfoForVI',
  PRIMARY_HEARING_CONNECT_RECORDED = 'PrimaryHearingConnectRecorded',
  PRIMARY_HEARING_DISCONNECT_RECORDED = 'PrimaryHearingDisconnectRecorded',
  TWO_LINE_VCO_CONNECT_RECORDED = 'TwoLineVcoConnectRecorded',
  TWO_LINE_VCO_DISCONNECT_RECORDED = 'TwoLineVcoDisconnectRecorded',
  SIGN_MAIL_CONNECT_RECORDED = 'SignMailConnectRecorded',
  SIGN_MAIL_DISCONNECT_RECORDED = 'SignMailDisconnectRecorded',
  DEAF_MUTE_STATUS_CHANGE = 'DeafMuteStatusChange',
}
